export enum Currency {
  USD = "USD",
  EUR = "EUR",
  GBP = "GBP",
}

export enum CurrencyKeys {
  CODE = "code",
  NAME = "name",
  SYMBOL = "symbol",
  IS_ZERO_DECIMAL = "isZeroDecimal",
}
